import {
  NetworkChatIcon,
  FollowIcon,
  FollowingIcon,
  HandShakeSimpleIcon,
  FollowingIconV2,
  IgnoreNewIcon,
  AcceptNewIcon,  
} from '@mybridge/icons';
import { MeetingDefaultIcon } from '@mybridge/icons/NotificationIcons';
import { HStack, IconButton, Tooltip, Button, Box, useDisclosure } from '@mybridge/ui';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { forwardRef, useContext, useState } from 'react';
import { MyNetworkContext } from '../network/context';
import {MyNetworkCircleCardMenu} from "../../../mybridgev4/snippets/profile/network/circle-menu";
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { GlobalMatrixPopup } from 'v4/snippets/globalMatrixPopup';
import { getMatrixUserId, getRoomIdFromLS } from 'v4/utils/utils';
import { useRouter } from 'next/router';
import { ForceSignInWrapper } from '../force-sign-in-wrapper';
export const UserNetworkingActions = forwardRef(
  ({ user, size, showHandshakeOnly,fromOnboarding=false,highlightFollow=false,...props }, ref) => {
    const networkCtx = useContext(MyNetworkContext);
    const router = useRouter();
    const { t } = useTranslator();
    const { startChatSingle } = useContext(MatrixContext);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [confirmAction, setConfirmAction] = useState(() => () => {});
    const { startMeetingSingle } = useContext(MatrixContext);
    const {
      isFollowed,
      isFriend,
      followUser,
      unfollowUser,
      handshakeUser,
      unfollowLoading,
      handshakeLoading,
      followLoading,
      isHandshaked,
      setSelectedUser,
      selectedUser,
      handleHandshakeSendRevoke,
      revokeHandshakeLoading,
      rejectInvitationLoading,
      acceptInvitationLoading,
      pendingInvitations,
      rejectInvitation,
      acceptInvitation,
      getRequestedAndSenderUserInfoFromUser
    } = networkCtx ?? {};

    const handshakeRecieved = pendingInvitations?.find(invite => invite?.user_info?.id === user?.id)

    return isFriend?.(user) ? (
      <HStack {...props}>
        <Tooltip label={t('meeting.chat') || "Chat"}>
          <IconButton
            // onClick={(e) => {
            //   startChatSingle?.(user);
            // }}
            onClick={() => {
              // const matrixUserId = getMatrixUserId(user?.id);
              
              // if (!(user?.connection?.chat_room_id || matrixUserId)) {
              //   setConfirmAction(() => (newId) => {
              //     startChatSingle?.({...user, matrix_user_id: newId});
              //   });
              //   onOpen();
              // } else {
              //   if(!user?.matrix_user_id){
              //     startChatSingle?.({...user, matrix_user_id: matrixUserId});
              //   }else{
              //     startChatSingle?.(user);
              //   }
              // }
              const roomId = getRoomIdFromLS(user?.id);
              router.push(`/profile/message?user=${roomId}`);
            }}
            bg="none"
              width="30px"
              height="40px"
              borderRadius="50%"
              border="1px solid #00000033"
            size={size ? size : 'md'}
          >
            <NetworkChatIcon
              width={size === 'sm' ? 8 : 20}
              height={size === 'sm' ? 8 : 20}
            />
          </IconButton>
        </Tooltip>
        <Tooltip label={t('publicProfile.meeting') || "Meeting"}>
          <IconButton
            onClick={(e) => {
              startMeetingSingle?.(user);
            }}
            bg="none"
              width="30px"
              height="40px"
              borderRadius="50%"
              border="1px solid #00000033"
            size={size ? size : 'md'}
          >
            <MeetingDefaultIcon
              width={size === 'sm' ? 8 : 20}
              height={size === 'sm' ? 8 : 20}
            />
          </IconButton>
        </Tooltip>
        <MyNetworkCircleCardMenu fromOnboarding={fromOnboarding} user={user} />
        <GlobalMatrixPopup
          isOpen={isOpen}
          onClose={onClose}
          onConfirm={confirmAction}
          selectedUserId={user?.id}
        />
      </HStack>
    ) : (
      <HStack {...props}>
        {showHandshakeOnly ? (
          <>
            {isHandshaked?.(user) ? (
              <>
                <Tooltip label={user?.is_blocked ? 'User is blocked': t('publicProfile.withdrawHandshake') || "Withdraw Handshake"}>
                  <IconButton
                  type="button"
                    onClick={(e) => {
                      if(user?.is_blocked) return;
                      //  e.preventDefault();
                       e.stopPropagation(); // optional, if nested inside clickable elements

                      setSelectedUser?.(user);
                      handleHandshakeSendRevoke?.(user);
                    }}
                    bg="none"
                    width="40px"
                    height="40px"
                    borderRadius="50%"
                    isDisabled={user?.is_blocked}
                    border="1px solid #00000033"
                    isLoading={
                      revokeHandshakeLoading && selectedUser?.id === user?.id
                    }
                    size={size ? size : 'md'}
                    icon={
                      <HandShakeSimpleIcon
                        color="rgb(179, 140, 140)"
                        width={20}
                        height={20}
                      />
                    }
                  />
                </Tooltip>
                
                {/* {highlightFollow && ( */}
                {(
                  <Tooltip label={isFollowed?.(user) ? (t('profileNetwork.following') || 'Following') : (t('publicProfile.follow') || 'Follow')}>
                    <IconButton
                      isDisabled={isFollowed?.(user)}
                      onClick={(e) => {
                        setSelectedUser?.(user);
                        followUser?.(user);
                      }}
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      variant="none"
                      _hover={{
                        bg: 'gray.100',
                      }}
                    >
                      <FollowIcon
                        width={20}
                        height={20}
                      />
                    </IconButton>
                  </Tooltip>
                )}
                <MyNetworkCircleCardMenu fromOnboarding={fromOnboarding} user={user} />
              </>
            ) : (
              <>
                <Tooltip label={user?.is_blocked ? 'User is blocked' : t('publicProfile.sendHandshakeRequest') || "Send Handshake Request"}>
                  <IconButton
                    type="button"
                    onClick={(e) => {
                      //  e.preventDefault();
                      e.stopPropagation(); // optional, if nested inside clickable elements
                      setSelectedUser?.(user);
                      handshakeUser?.(user,fromOnboarding?"onboarding":null);
                    }}
                    bg="none"
                    width="40px"
                    height="40px"
                    isDisabled={user?.is_blocked}
                    borderRadius="50%"
                    border="1px solid #00000033"
                    isLoading={handshakeLoading && selectedUser?.id === user?.id}
                    icon={
                      <HandShakeSimpleIcon
                        {...(isHandshaked?.(user) ? {} : { color: 'rgb(148, 176, 150)' })}
                        width={20}
                        height={20}
                      />
                    }
                  />
                </Tooltip>
                {!isFollowed?.(user) ? (
                  <Tooltip label={(t('publicProfile.follow') || "Follow")}>
                    <IconButton
                      isDisabled={isFollowed?.(user)}
                      onClick={(e) => {
                        setSelectedUser?.(user);
                        followUser?.(user);
                      }}
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      variant="none"
                      isLoading={followLoading && selectedUser?.id === user?.id}
                      _hover={{
                        bg: 'gray.100',
                      }}
                      icon={
                        <FollowIcon
                          width={20}
                          height={20}
                        />
                      }
                    />
                  </Tooltip>
                ):(
                  <Tooltip label={t('publicProfile.following') || "Following"}>
                    <IconButton
                      onClick={(e) => unfollowUser(user)}
                      w={'41px'}
                      height={'41px'}
                      border={'1px solid #00000033'}
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius={'50%'}
                      variant="none"
                      isLoading={unfollowLoading && selectedUser?.id === user?.id}
                      // isLoading={followLoading && selectedUser?.id === user?.id}//i want loader here
                      _hover={{
                        bg: "gray.200"
                      }}
                      icon={
                        <FollowingIconV2
                          width={20}
                          height={20}
                        />
                      }
                    />
                </Tooltip>
                )}
                <MyNetworkCircleCardMenu fromOnboarding={fromOnboarding} user={user} />
              </>
            )}
          </>
        ) : (
          <>
            {/* MARK: FOLLOW/UNFOLLOW ICON */}
            {isFollowed?.(user) ? (
              <Tooltip label={t('publicProfile.following') || "Following"} bg="black" p={2}>
                <ForceSignInWrapper>
                  <IconButton
                    isDisabled={!isFollowed?.(user)}
                    onClick={(e) => {
                      setSelectedUser?.(user);
                      unfollowUser?.(user);
                    }}
                    isLoading={unfollowLoading && selectedUser?.id === user?.id}
                    size={size ? size : 'md'}
                    w={'41px'}
                    height={'41px'}
                    border={'1px solid #00000033'}
                    cursor="pointer"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius={'50%'}
                    variant="none"
                    _hover={{
                      bg: 'gray.100',
                    }}
                    icon={
                      <FollowingIconV2 width="20" height="20" />
                    }
                  />
                </ForceSignInWrapper>
              </Tooltip>
            ) : (
              <Tooltip label={t('publicProfile.follow') || "Follow"} bg="black" p={2}>
                <ForceSignInWrapper>
                  <IconButton
                    isDisabled={isFollowed?.(user)}
                    onClick={(e) => {
                      setSelectedUser?.(user);
                      followUser?.(user);
                    }}
                    isLoading={followLoading && selectedUser?.id === user?.id}
                    size={size ? size : 'md'}
                    w={'41px'}
                    height={'41px'}
                    border={'1px solid #00000033'}
                    cursor="pointer"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius={'50%'}
                    variant="none"
                    _hover={{
                      bg: 'gray.100',
                    }}
                    icon={
                      <FollowIcon
                        width={20}
                        height={20}
                      />
                    }
                  />
                </ForceSignInWrapper>
              </Tooltip>
            )} 
            
            
            {/* MARK: HANDSHAKE ICON */}
            {!handshakeRecieved ? (
              <Tooltip
                label={user?.is_blocked ? "User is blocked" : (isHandshaked?.(user) ? t('postActionMenu.withdrawHandshake') || 'Withdraw handshake' : t('publicProfile.handshake') || 'Handshake')}
              >
                <IconButton
                  onClick={(e) => {
                    if(user?.is_blocked) return;
                    if((handshakeLoading || revokeHandshakeLoading) && user?.id===selectedUser?.id) return;
                    setSelectedUser?.(user);
                    e.preventDefault();
                    e.stopPropagation(); // optional, if nested inside clickable elements

                    {isHandshaked?.(user) ? handleHandshakeSendRevoke(user) : handshakeUser(user, fromOnboarding?"onboarding":null)}
                  }}
                  isLoading={(handshakeLoading || revokeHandshakeLoading) && user?.id===selectedUser?.id}
                  isDisabled={user?.is_blocked || ((handshakeLoading || revokeHandshakeLoading) && user?.id===selectedUser?.id)}
                  
                  icon={
                    <HandShakeSimpleIcon
                      {...(isHandshaked?.(user) ? {color: 'rgb(179, 140, 140)'} : { color: 'rgb(148, 176, 150)' })}
                      width="20"
                      height="20"
                    />
                  }
                  w={'41px'}
                  height={'41px'}
                  border={'1px solid #00000033'}
                  cursor="pointer"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius={'50%'}
                  variant="none"
                  _hover={{
                    bg: 'gray.100',
                  }}
                /> 
              </Tooltip>
            ) : (
              <HStack justifyContent={["center","flex-start"]} >
                <Tooltip label={t('profileNetwork.ignore') || "Ignore"}>
                  <IconButton
                    onClick={() => {
                      if(pendingInvitations && user){
                        const extractedUser = getRequestedAndSenderUserInfoFromUser(user, pendingInvitations)
                        rejectInvitation?.(extractedUser);
                      }
                    }}
                    bg="none"
                    isLoading={
                      rejectInvitationLoading
                    }
                    width="30px"
                    height="40px"
                    borderRadius="50%"
                    border="1px solid #00000033"
                    icon={<IgnoreNewIcon />}
                  />
                </Tooltip>

                <Tooltip label={t('profileNetwork.accept') || "Accept"}>
                  <IconButton
                    bg="none"
                    width="30px"
                    height="40px"
                    borderRadius="50%"
                    border="1px solid #00000033"
                    isLoading={
                      acceptInvitationLoading
                    }
                    onClick={() => {
                      if(pendingInvitations && user){
                        const extractedUser = getRequestedAndSenderUserInfoFromUser(user, pendingInvitations)
                        acceptInvitation(extractedUser);
                      }
                    }}
                    icon={<AcceptNewIcon />}
                  />
                </Tooltip>
              </HStack> 
            )}
          </>
        )}
      </HStack>
    );
  }
);
